import actionName from "../action-creator";
import { types } from "./generator-products.actions";

const GENERATOR_PRODUCTS = `[GENERATOR_PRODUCTS]`;

const initialState = {
    sessionId: null,
    sessionGuid: null,
    items: [],
    previous: null,
};

function generatorProductsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case actionName(GENERATOR_PRODUCTS, types.SET):
            return {
                ...payload,
                previous: state.items.length
                    ? {
                        sessionId: state.sessionId,
                        sessionGuid: state.sessionGuid,
                        items: state.items,
                    }
                    : state.previous,
            };
        case actionName(GENERATOR_PRODUCTS, types.RESTORE_PREVIOUS):
            if (!state.previous) {
                return state;
            }
            return {
                ...state.previous,
                previous: null,
            };
        case actionName(GENERATOR_PRODUCTS, types.RESTORE_INITIAL):
            return initialState;
        default:
            return state;
    }
}

export { initialState, GENERATOR_PRODUCTS };

export default generatorProductsReducer;
